import { render, staticRenderFns } from "./CopyCoordinates.vue?vue&type=template&id=0bd33e35&scoped=true&"
import script from "./CopyCoordinates.vue?vue&type=script&lang=js&"
export * from "./CopyCoordinates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd33e35",
  null
  
)

export default component.exports